import {Injectable} from '@angular/core';
import {BaseEndpointService} from '../base-endpoint-service';
import {Backend} from '@generated-backend-types';
import {ListItem} from "src/app/entities/list-item.entity";
import TeamMember = Backend.App.Resources.Dashboard.Administration.TeamMember;
import TeamMemberData = Backend.App.Data.Dashboard.Administration.TeamMemberData;

@Injectable({providedIn: 'root'})
export class TeamMemberService extends BaseEndpointService<TeamMember, TeamMemberData> {
  protected override endpoint = '/administration/team-members';

  public override modelToMultiSelectItem(m: TeamMember): ListItem & { model: TeamMember; } {
    return {
      id: m.id,
      text: `${m.first_name} ${m.last_name}`,
      isDisabled: false,
      model: m,
    }
  }
}
